import type { Leg } from "./types.ts";

export interface TrackRequest {
  hash?: string;
  chainId?: string;
  depositAddress?: string;
}

export interface TrackResponse {
  chainId: string;
  hash: string;
  block: number;
  type: string;
  status: string;
  trackingStatus: string;
  fromAsset: string;
  fromAmount: string;
  fromAddress: string;
  toAsset: string;
  toAmount: string;
  toAddress: string;
  finalisedAt: number;
  meta?: unknown;
  payload?: unknown;
  legs?: Leg[];
}

const TERMINAL_STATUSES = ["completed", "refunded", "failed"];

export function isTerminal(resp: TrackResponse): boolean {
  if (TERMINAL_STATUSES.includes(resp.status)) return true;

  // Cross-chain swaps (especially involving Zcash) can have the top-level
  // status lag behind leg completion. If the final outbound leg already
  // reports a terminal status, treat the whole swap as terminal.
  if (resp.legs?.length) {
    const lastLeg = resp.legs[resp.legs.length - 1]!;
    if (TERMINAL_STATUSES.includes(lastLeg.status)) return true;
  }

  return false;
}

/**
 * True if the swap actually succeeded (not just reached a terminal state
 * like refunded/failed). Checks both top-level status and the final leg.
 */
export function isCompleted(resp: TrackResponse): boolean {
  if (resp.status === "completed") return true;

  if (resp.legs?.length) {
    const lastLeg = resp.legs[resp.legs.length - 1]!;
    if (lastLeg.status === "completed" && lastLeg.hash) return true;
  }

  return false;
}
